var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useEffect, useRef, useState } from "react";
import { setupProxyTrap, setupContextTrap, } from "@atlassiansox/microscope-panel-utils";
import { domainNameForDeployment, getApiUrl, hasDeployment, hasLocalDevPermission, parseQuery, ProxyErrorMsg, } from "./utils";
import querystring from "querystring";
import { keyBy } from "lodash";
import { useAnalytics, useShowFlag, useTheme, useUser, useQuery, isSufficientPermission, Permission, useApolloClient, } from "@atlassiansox/microscopekit";
import serviceInfoForContextQuery from "./service-info-context.query.graphql";
import deploymentInfoForContextQuery from "./deployment-info-context.query.graphql";
import servicePermissionQuery from "./service-permission.query.graphql";
import servicePanelsQuery from "./panels-manager/panels.query.graphql";
import searchQuery from "./panels-manager/search-panels.query.graphql";
export var LoadStatus;
(function (LoadStatus) {
    LoadStatus["LOADING"] = "loading";
    LoadStatus["LOADED"] = "loaded";
    LoadStatus["FAILED"] = "failed";
})(LoadStatus || (LoadStatus = {}));
export var useFetchHandler = function (serviceId, panelId, env, envType) {
    var proxyListener = useRef();
    var showFlag = useShowFlag();
    var track = useAnalytics();
    useEffect(function () {
        var _a;
        (_a = proxyListener.current) === null || _a === void 0 ? void 0 : _a.cancel();
        var handler = function (path, options) {
            var headers = new Headers(options === null || options === void 0 ? void 0 : options.headers);
            headers.set("x-service-name", serviceId);
            headers.set("x-panel-name", panelId);
            headers.set("x-service-env", env);
            var p = path.startsWith("/") ? path : "/" + path;
            return fetch(getApiUrl() + "/panel-proxy" + p, __assign(__assign({}, options), { headers: headers, credentials: "include" })).then(function (response) { return __awaiter(void 0, void 0, void 0, function () {
                var statusFromProxy, method, reason, _a, msg, status, statusText, responseHeaders, responseCopy, resBlob;
                var _b;
                return __generator(this, function (_c) {
                    switch (_c.label) {
                        case 0:
                            statusFromProxy = response.status;
                            if (!(statusFromProxy !== 200)) return [3 /*break*/, 3];
                            method = (_b = options === null || options === void 0 ? void 0 : options.method) !== null && _b !== void 0 ? _b : "GET";
                            _a = response.statusText;
                            if (_a) return [3 /*break*/, 2];
                            return [4 /*yield*/, response.text()];
                        case 1:
                            _a = (_c.sent());
                            _c.label = 2;
                        case 2:
                            reason = _a || "Unknown";
                            msg = "Microscope failed to proxy request to path " + path + " with method " + method + ". Status Code: " + statusFromProxy + ". Reason: " + reason;
                            showFlag({
                                title: "Microscope failed to proxy a request",
                                message: (React.createElement(ProxyErrorMsg, { url: p, method: method, status: "" + statusFromProxy, reason: reason })),
                                disableAutoDismiss: true,
                                type: "error",
                            });
                            track("PanelPlugin: FetchProxyFailed", {
                                category: "error",
                                statusCode: statusFromProxy,
                            });
                            return [2 /*return*/, Promise.reject(new Error(msg))];
                        case 3:
                            status = response.headers.get("x-service-response-code");
                            statusText = response.headers.get("x-service-response-message");
                            responseHeaders = new Headers(response.headers);
                            responseHeaders.delete("x-service-response-code");
                            responseHeaders.delete("x-service-response-message");
                            responseCopy = response.clone();
                            return [4 /*yield*/, response.blob()];
                        case 4:
                            resBlob = _c.sent();
                            return [2 /*return*/, new Response(resBlob.size ? responseCopy.body : null, {
                                    status: status ? parseInt(status, 10) : 500,
                                    statusText: statusText !== null && statusText !== void 0 ? statusText : "",
                                    headers: responseHeaders,
                                })];
                    }
                });
            }); });
        };
        proxyListener.current = setupProxyTrap(handler, {
            domain: domainNameForDeployment(envType),
        });
        return function () {
            var _a;
            (_a = proxyListener.current) === null || _a === void 0 ? void 0 : _a.cancel();
        };
    }, [env, serviceId, panelId, envType]);
};
var useGetServiceInfo = function (serviceId) {
    var client = useApolloClient();
    return function () { return __awaiter(void 0, void 0, void 0, function () {
        var data, s, service;
        var _a, _b, _c;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0: return [4 /*yield*/, client.query({
                        query: serviceInfoForContextQuery,
                        variables: { id: serviceId },
                    })];
                case 1:
                    data = (_d.sent()).data;
                    s = data === null || data === void 0 ? void 0 : data.service;
                    service = {
                        id: s === null || s === void 0 ? void 0 : s.id,
                        name: s === null || s === void 0 ? void 0 : s.id,
                        platform: "micros",
                        owner: s === null || s === void 0 ? void 0 : s.metadata.owner.id,
                        tier: "" + (s === null || s === void 0 ? void 0 : s.metadata.sla.serviceTier),
                        members: ((_a = s === null || s === void 0 ? void 0 : s.metadata.admins) !== null && _a !== void 0 ? _a : []).map(function (a) { return a.id; }),
                        ssamUrl: (_c = (_b = s === null || s === void 0 ? void 0 : s.metadata) === null || _b === void 0 ? void 0 : _b.ssamContainer) === null || _c === void 0 ? void 0 : _c.url,
                    };
                    return [2 /*return*/, service];
            }
        });
    }); };
};
var useGetDeploymentInfo = function (serviceId) {
    var client = useApolloClient();
    return function () { return __awaiter(void 0, void 0, void 0, function () {
        var data, envs, deployments;
        var _a, _b, _c, _d, _e;
        return __generator(this, function (_f) {
            switch (_f.label) {
                case 0: return [4 /*yield*/, client.query({
                        query: deploymentInfoForContextQuery,
                        variables: { id: serviceId },
                    })];
                case 1:
                    data = (_f.sent()).data;
                    envs = (_e = (_d = (_c = (_b = (_a = data === null || data === void 0 ? void 0 : data.service) === null || _a === void 0 ? void 0 : _a.microsV2) === null || _b === void 0 ? void 0 : _b.shard) === null || _c === void 0 ? void 0 : _c.environments) === null || _d === void 0 ? void 0 : _d.items) !== null && _e !== void 0 ? _e : [];
                    deployments = (envs !== null && envs !== void 0 ? envs : []).reduce(function (acc, e) {
                        var _a;
                        var _b, _c, _d, _e, _f, _g, _h;
                        var clean = function (dep) {
                            if (!dep) {
                                return null;
                            }
                            var __typename = dep.__typename, others = __rest(dep, ["__typename"]);
                            return __assign(__assign({}, others), { id: dep.id.split("--").pop() });
                        };
                        return __assign(__assign({}, acc), (_a = {}, _a[e.name] = {
                            env: e.name,
                            deployments: {
                                stable: clean((_b = e.deployments) === null || _b === void 0 ? void 0 : _b.stable),
                                canary: clean((_c = e.deployments) === null || _c === void 0 ? void 0 : _c.canary),
                                previous: clean((_d = e.deployments) === null || _d === void 0 ? void 0 : _d.previous),
                                persistent: ((_f = (_e = e.deployments) === null || _e === void 0 ? void 0 : _e.persistent) !== null && _f !== void 0 ? _f : []).map(function (d) { return clean(d); }),
                                other: ((_h = (_g = e.deployments) === null || _g === void 0 ? void 0 : _g.other) !== null && _h !== void 0 ? _h : []).map(function (d) { return clean(d); }),
                            },
                        }, _a));
                    }, {});
                    return [2 /*return*/, deployments];
            }
        });
    }); };
};
var useUserInfo = function () {
    var userRef = useRef();
    var user = useUser();
    userRef.current = {
        id: user.username,
        email: user.email,
        displayName: user.givenName + " " + user.familyName,
        firstName: user.givenName,
        lastName: user.familyName,
        location: user.office,
    };
    return userRef;
};
var useAppContext = function () {
    var appRef = useRef();
    var theme = useTheme();
    appRef.current = { theme: theme.mode };
    return appRef;
};
export var useContextHandlers = function (serviceId, envType, env) {
    var contextListener = useRef();
    var getServiceInfo = useGetServiceInfo(serviceId);
    var getDeploymentInfo = useGetDeploymentInfo(serviceId);
    var userInfo = useUserInfo();
    var appInfo = useAppContext();
    useEffect(function () {
        var clearListeners = function () {
            var _a, _b, _c, _d, _e, _f;
            (_a = contextListener.current) === null || _a === void 0 ? void 0 : _a.getAppContext.cancel();
            (_b = contextListener.current) === null || _b === void 0 ? void 0 : _b.getServiceInfo.cancel();
            (_c = contextListener.current) === null || _c === void 0 ? void 0 : _c.getCurrentUser.cancel();
            (_d = contextListener.current) === null || _d === void 0 ? void 0 : _d.getCurrentEnv.cancel();
            (_f = (_e = contextListener.current) === null || _e === void 0 ? void 0 : _e.getDeploymentInfo) === null || _f === void 0 ? void 0 : _f.cancel();
        };
        clearListeners();
        contextListener.current = setupContextTrap({
            getServiceInfo: getServiceInfo,
            getDeploymentInfo: getDeploymentInfo,
            getCurrentUser: function () { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
                return [2 /*return*/, userInfo.current];
            }); }); },
            getAppContext: function () { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
                return [2 /*return*/, appInfo.current];
            }); }); },
            getCurrentEnv: function () { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
                return [2 /*return*/, env];
            }); }); },
        }, { domain: domainNameForDeployment(envType) });
        return function () {
            clearListeners();
        };
    }, [serviceId, envType, env]);
};
/*
 * For local dev since the panel content is loaded from localhost,
 * we can't really tell whether the content was loaded correctly by using the browser API (because CORS)
 * But we have a way. On load of the js post-robot initializes itself by sending a hello message to the host
 * and we can basically listen for that message, if we got a message, it means a panel is loaded with content in localhost!
 *
 * The assumption here is that, the panel will import the microscope-panel-utils at least once in the initial code path
 * so that the side effect of the import takes place
 * */
export var usePanelLoadDetector = function (panelId, envType) {
    var _a = useState(LoadStatus.LOADING), loadStatus = _a[0], setLoadStatus = _a[1];
    var timeout = useRef();
    useEffect(function () {
        if (envType === "local") {
            return;
        }
        setLoadStatus(function () { return LoadStatus.LOADING; });
        hasDeployment(panelId, envType).then(function (r) {
            setLoadStatus(function () { return (r ? LoadStatus.LOADED : LoadStatus.FAILED); });
        });
    }, [panelId, envType]);
    useEffect(function () {
        if (envType !== "local") {
            return;
        }
        var onMessage = function (e) {
            // discard other junks from devtools and what not
            if (e.origin !== domainNameForDeployment(envType)) {
                return;
            }
            setLoadStatus(function () { return LoadStatus.LOADED; });
        };
        setLoadStatus(function () { return LoadStatus.LOADING; });
        var t = timeout.current;
        window.removeEventListener("message", onMessage);
        clearTimeout(t);
        window.addEventListener("message", onMessage);
        // we will wait at most 3 seconds, if we didn't hear anything from the iframe yet, chances are nothing loaded there
        timeout.current = setTimeout(function () {
            setLoadStatus(function (curr) {
                return curr === LoadStatus.LOADED ? LoadStatus.LOADED : LoadStatus.FAILED;
            });
        }, 3000);
        return function () {
            window.removeEventListener("message", onMessage);
            clearTimeout(t);
        };
    }, [panelId, envType]);
    return loadStatus;
};
export var useLocalDevToggle = function (query, history, service, panel) {
    var q = parseQuery(query);
    var _a = useState(q.local === "true"), localDev = _a[0], setLocalDev = _a[1];
    useEffect(function () {
        setLocalDev(q.local === "true");
    }, [q.local]);
    useEffect(function () {
        var _a = parseQuery(query), local = _a.local, rest = __rest(_a, ["local"]);
        var newQuery = querystring.stringify(__assign(__assign({}, rest), (localDev ? { local: "true" } : {})));
        history.replace({
            search: newQuery,
        });
    }, [localDev, history, query]);
    useEffect(function () {
        var _a;
        if (!(service === null || service === void 0 ? void 0 : service.service) || !((_a = panel === null || panel === void 0 ? void 0 : panel.panel) === null || _a === void 0 ? void 0 : _a.service)) {
            return;
        }
        var yes = hasLocalDevPermission(service.service, panel === null || panel === void 0 ? void 0 : panel.panel.service);
        if (!yes) {
            setLocalDev(function () { return false; });
        }
    }, [service, panel]);
    return { localDev: localDev, toggleDev: function () { return setLocalDev(function (v) { return !v; }); }, setLocalDev: setLocalDev };
};
export var useMicrosEnvironment = function (envs, query, history) {
    var _a;
    var q = parseQuery(query);
    var _b = useState((_a = q.env) !== null && _a !== void 0 ? _a : ""), currentEnv = _b[0], setCurrentEnv = _b[1];
    useEffect(function () {
        if (!envs.length) {
            return;
        }
        var q = parseQuery(query);
        var environments = keyBy(envs, "env");
        if (!environments[q.env]) {
            setCurrentEnv(envs[0].env);
        }
    }, [query, envs]);
    useEffect(function () {
        var newQuery = querystring.stringify(__assign(__assign({}, parseQuery(query)), { env: currentEnv }));
        history.replace({
            search: newQuery,
        });
    }, [currentEnv, history, query]);
    return { currentEnv: currentEnv, setCurrentEnv: setCurrentEnv };
};
export var useKeyPress = function (targetKey, handler) {
    useEffect(function () {
        var downHandler = function (e) {
            if (e.key === targetKey) {
                handler();
            }
        };
        window.addEventListener("keydown", downHandler);
        return function () {
            window.removeEventListener("keydown", downHandler);
        };
    }, [targetKey]);
};
export var usePanels = function (id) {
    var _a, _b;
    var _c = useQuery(servicePanelsQuery, { variables: { id: id } }), data = _c.data, error = _c.error, loading = _c.loading, refetch = _c.refetch;
    var panels = ((_b = (_a = data === null || data === void 0 ? void 0 : data.service) === null || _a === void 0 ? void 0 : _a.panels) !== null && _b !== void 0 ? _b : []).map(function (p) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
        var isDeleted = !p.service;
        return {
            name: p.name,
            description: (_c = (_b = (_a = p.service) === null || _a === void 0 ? void 0 : _a.metadata) === null || _b === void 0 ? void 0 : _b.description) !== null && _c !== void 0 ? _c : " ",
            installedBy: p.installedBy.id,
            installedAt: p.installedAt,
            owner: (_g = (_f = (_e = (_d = p.service) === null || _d === void 0 ? void 0 : _d.metadata) === null || _e === void 0 ? void 0 : _e.owner) === null || _f === void 0 ? void 0 : _f.id) !== null && _g !== void 0 ? _g : " ",
            ssamContainerName: (_l = (_k = (_j = (_h = p.service) === null || _h === void 0 ? void 0 : _h.metadata) === null || _j === void 0 ? void 0 : _j.ssamContainer) === null || _k === void 0 ? void 0 : _k.id) !== null && _l !== void 0 ? _l : " ",
            isDeleted: isDeleted,
        };
    });
    return {
        service: data === null || data === void 0 ? void 0 : data.service,
        panels: panels,
        loading: loading,
        error: error,
        refetch: refetch,
    };
};
export var useIsServiceAdmin = function (id) {
    var _a;
    var data = useQuery(servicePermissionQuery, { variables: { id: id } }).data;
    return (((_a = data === null || data === void 0 ? void 0 : data.service) === null || _a === void 0 ? void 0 : _a.currentUserPermission) &&
        isSufficientPermission(data.service.currentUserPermission, Permission.Write));
};
var buildQuery = function (q) {
    var baseQ = "platform: panel";
    var fuzzQ = q
        ? " AND ( name:(\"" + q + "\"~) OR description:(\"" + q + "\"~) OR owner:(\"" + q + "\"~) )"
        : "";
    return "" + baseQ + fuzzQ;
};
export var useSearch = function (serviceId) {
    var _a;
    var _b = useState(buildQuery()), query = _b[0], setQuery = _b[1];
    var _c = useQuery(searchQuery, {
        variables: { query: query, first: 100 },
    }), data = _c.data, loading = _c.loading;
    var panels = ((_a = data === null || data === void 0 ? void 0 : data.search.edges) !== null && _a !== void 0 ? _a : [])
        .filter(function (e) { return e !== null && e.node !== null; })
        .filter(function (e) {
        var _a, _b, _c;
        var panel = e.node;
        var restrictions = (_c = (_b = (_a = panel.attributes.panelInfoAttribute) === null || _a === void 0 ? void 0 : _a.value) === null || _b === void 0 ? void 0 : _b.services) !== null && _c !== void 0 ? _c : [];
        if (!restrictions.length) {
            return true;
        }
        return restrictions.includes(serviceId);
    })
        .map(function (d) {
        var _a, _b, _c, _d;
        var panel = d.node;
        return {
            name: panel === null || panel === void 0 ? void 0 : panel.id,
            description: (_b = (_a = panel.metadata) === null || _a === void 0 ? void 0 : _a.description) !== null && _b !== void 0 ? _b : " ",
            owner: (_d = (_c = panel === null || panel === void 0 ? void 0 : panel.metadata) === null || _c === void 0 ? void 0 : _c.owner) === null || _d === void 0 ? void 0 : _d.id,
            ssamContainerName: panel.metadata.ssamContainer.id,
        };
    });
    return {
        loading: loading,
        query: query,
        updateQuery: function (q) { return setQuery(function () { return buildQuery(q); }); },
        panels: panels,
    };
};
